import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
export let EChatActivityStatus;
(function (EChatActivityStatus) {
  EChatActivityStatus["Pending"] = "pending";
  EChatActivityStatus["Closed"] = "closed";
  EChatActivityStatus["Assigned"] = "assigned";
  EChatActivityStatus["Unassigned"] = "unassigned";
})(EChatActivityStatus || (EChatActivityStatus = {}));
export let EChatActivityChatActivitiesReason;
(function (EChatActivityChatActivitiesReason) {
  EChatActivityChatActivitiesReason["NoFurtherAction"] = "no-further-action";
  EChatActivityChatActivitiesReason["NotRelevant"] = "not-relevant";
  EChatActivityChatActivitiesReason["Spam"] = "spam";
  EChatActivityChatActivitiesReason["Offensive"] = "offensive";
  EChatActivityChatActivitiesReason["NotActionable"] = "not-actionable";
  EChatActivityChatActivitiesReason["Other"] = "other";
})(EChatActivityChatActivitiesReason || (EChatActivityChatActivitiesReason = {}));
export let EChatActivityTag;
(function (EChatActivityTag) {
  EChatActivityTag["Reschedule"] = "reschedule";
  EChatActivityTag["Cancel"] = "cancel";
  EChatActivityTag["RxRefill"] = "rx-refill";
  EChatActivityTag["Labs"] = "labs";
  EChatActivityTag["NoAction"] = "no-action";
  EChatActivityTag["NeedsReview"] = "needs-review";
})(EChatActivityTag || (EChatActivityTag = {}));
export const fieldsChatActivity = _extends({}, fieldsIBaseModel, {
  assignee: {
    type: 'ID',
    ref: EModel.User
  },
  automated: {
    type: 'Boolean'
  },
  description: {
    type: 'Text'
  },
  facilities: {
    type: 'ID',
    ref: EModel.Facility,
    array: true
  },
  groupAssignee: {
    type: 'ID',
    ref: EModel.Group
  },
  lastIrregularAt: {
    type: 'Date'
  },
  lastMessage: {
    type: 'ID',
    ref: EModel.Message
  },
  patient: {
    type: 'ID',
    ref: EModel.Patient
  },
  previousAssignee: {
    type: 'ID',
    ref: EModel.User
  },
  previousGroupAssignee: {
    type: 'ID',
    ref: EModel.Group
  },
  priorityUpdatedAt: {
    type: 'Date'
  },
  reason: {
    type: 'Option',
    values: EChatActivityChatActivitiesReason
  },
  status: {
    type: 'Option',
    values: EChatActivityStatus
  },
  statusReason: {
    type: 'Option',
    values: EChatActivityChatActivitiesReason
  },
  tags: {
    type: 'Option',
    values: EChatActivityTag,
    array: true
  },
  to: {
    type: 'ID',
    ref: EModel.User
  },
  unreadMessages: {
    type: 'Number'
  }
});